import { Howl } from 'howler';
import { create } from 'zustand';

const seModules = import.meta.glob('/assets/se/season2/*.mp3', {
  eager: true,
  import: 'default',
}) as Record<string, string>;

const allMergeSe = Object.values(seModules).filter(
  (src): src is string => typeof src === 'string',
);

const calculateSeVolume = (volume: number) => {
  return Math.max(0, Math.min(1, volume * 0.01));
};

type SeState = {
  mergeSounds: Howl[];
  seVolume: number;
  isInitialized: boolean;

  init: () => void;
  playMergeSound: () => void;
  setSeVolume: (volume: number) => void;
  destroy: () => void;
};

export const useSeStore = create<SeState>((set, get) => ({
  mergeSounds: [],
  seVolume: parseInt(localStorage.getItem('seVolume') || '25', 10),
  isInitialized: false,

  init: () => {
    const { seVolume } = get();
    const sounds = allMergeSe.map(
      (path) =>
        new Howl({
          src: [path],
          volume: calculateSeVolume(seVolume),
          preload: true,
        }),
    );
    set({ mergeSounds: sounds, isInitialized: true });
  },

  playMergeSound: () => {
    const { mergeSounds, isInitialized, init } = get();

    if (!isInitialized) {
      init();
      return get().playMergeSound();
    }

    if (mergeSounds.length === 0) return;

    const i = Math.floor(Math.random() * mergeSounds.length);
    mergeSounds[i].play();
  },

  setSeVolume: (volume: number) => {
    const { mergeSounds } = get();
    localStorage.setItem('seVolume', volume.toString());
    set({ seVolume: volume });

    const calculatedVolume = calculateSeVolume(volume);
    for (const sound of mergeSounds) {
      sound.volume(calculatedVolume);
    }
  },

  destroy: () => {
    const { mergeSounds } = get();
    for (const sound of mergeSounds) {
      sound.unload();
    }
    set({ mergeSounds: [], isInitialized: false });
  },
}));
